import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { ListLoader } from '@app/screens/pools/components/ListLoader';
import { usePositions } from '@app/hooks/v3/usePositions';
import { PositionsListRowV3 } from '@app/screens/positions/components/PositionsListRowV3';
import { CollectAllFeesButton } from '@app/screens/positions/components/CollectAllFeesButton';

import s from './PositionsList.module.scss';

export const VerifiedPositionsListV3 = () => {
  const { positions, loading: positionsLoading } = usePositions();

  return (
    <Box
      p={[0, '0 24px 24px']}
      borderRadius="16px"
      bg={['transparent', 'gray.3']}
      border={['none', '1px solid #232323']}
      mb={4}
    >
      <Box className={s.container}>
        <div className={s.header}>
          <Flex width="30%">Pool</Flex>
          <Flex width="10%">&nbsp;</Flex>
          <Flex width="10%">Amount</Flex>
          <Flex width="10%">Composition</Flex>
          <Flex width="5%">APR</Flex>
          <Flex width="20%" justifyContent="flex-end">
            <CollectAllFeesButton positions={positions} />
          </Flex>
        </div>
        {positionsLoading ? (
          <ListLoader />
        ) : (
          positions?.map(position => {
            return (
              <PositionsListRowV3 data={position} key={position.tokenId} />
            );
          })
        )}
      </Box>
    </Box>
  );
};
